import axios from 'axios'
import store from '../store/store'
// eslint-disable-next-line no-unused-vars  
import { Notification, MessageBox } from 'element-ui'
// import { getToken, setToken } from '@/utils/auth'

const service = axios.create({
  // api 的 base_url
  baseURL: 'https://crmapi.hooyagroup.com/',//'http://localhost:52599/',//
  timeout: 30000
  // 请求超时时间
})

// const pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// const CancelToken = axios.CancelToken
// const removeRepeatUrl = (ever) => {
//   for (const p in pending) {
//     if (pending[p].u === ever.url + '&' + ever.method) { // 当当前请求在数组中存在时执行函数体
//       pending[p].f() // 执行取消操作
//       pending.splice(p, 1) // 把这条记录从数组中移除
//     }
//   }
// }

// request拦截器
service.interceptors.request.use(
  config => {
    // removeRepeatUrl(config)
    // config.cancelToken = new CancelToken((c) => {
    //   // 自定义唯一标识
    //   pending.push({ u: config.url + '&' + config.method, f: c })
    // })

    // eslint-disable-next-line no-unused-vars  
    // eslint-disable-next-line no-debugger
    const Token = store.getters.getToken;
    if (Token) {
      // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['SYSTOKEN'] = Token
    }

    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // removeRepeatUrl(response.config)
    if (response.status !== 200) {
      switch (response.status) {
        case 400:
        case 403:
          Notification.error({
            title: response.data.msg,
            duration: 3000
          })
          break
        default:
          Notification.error({
            title: response.data.msg
          })
          break
      }
    } else {
      const res = response.data
      return res
    }
  },
  error => {

    // eslint-disable-next-line no-debugger
    if (error.response) {
      var response = error.response
      switch (response.status) {
        default:
          Notification.error({
            title: response.data.message || '请求接口失败',
            duration: 3000
          })
          break
      }
    } else {
      Notification.error({
        title: '网络错误，请求接口失败',
        duration: 3000
      })
    }

    return Promise.reject(error)
  }
)
export default service
